/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * Telugu: ఓం నమః శివాయ
 * Tamil: ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 */

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import APIHelper from "../api/APIHelper";
import envConfig from "../config/envConfig";
import AlertDialog from "../components/common/AlertDialog";
import { getPostAuthDestination } from "../utils/postAuthDestination";

const apiHelper = new APIHelper({
  apiUrl: envConfig.backendApiUrl,
  tokenUrl: envConfig.backendTokenUrl,
  clientId: envConfig.clientKey,
  clientSecret: envConfig.clientSecret,
});

const VERIFY_EMAIL_ENDPOINT = "/arcee/user/verify-email/";

function VerifyEmailPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("info");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const email = params.get("email");

    if (!token || !email) {
      setAlertTitle("Invalid Link");
      setAlertMessage("The verification link is invalid or incomplete.");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        const response = await apiHelper.apiCall(VERIFY_EMAIL_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, email }),
        });

        const data = await response.json();

        if (response.ok) {
          setAlertTitle("Success");
          setAlertMessage(data.message || "Email verified successfully! You can now log in.");
          setAlertType("success");
        } else {
          setAlertTitle("Verification Failed");
          setAlertMessage(data.error || "Verification failed. The link may be expired or invalid.");
          setAlertType("error");
        }
      } catch (error) {
        setAlertTitle("Error");
        setAlertMessage("An error occurred during verification. Please try again later.");
        setAlertType("error");
      } finally {
        setAlertOpen(true);
        setLoading(false);
      }
    };

    verify();
  }, [location.search]);

  const handleAlertOk = () => {
    setAlertOpen(false);
    navigate(getPostAuthDestination());
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      {loading && <p>Verifying your email...</p>}
      <AlertDialog
        open={alertOpen}
        title={alertTitle}
        message={alertMessage}
        type={alertType}
        okLabel={envConfig.isUserLoginAllowed ? "Go to Sign In" : "OK"}
        showCancel={false}
        onOk={handleAlertOk}
        onCancel={() => setAlertOpen(false)}
      />
    </div>
  );
}

export default VerifyEmailPage;
